import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class ZipCode extends AbstractModel {
  @autoserialize
  zipCode: string;

  @autoserialize
  latitude: number;

  @autoserialize
  longitude: number;
}
